import $ from 'jquery';
import Actions from '@ppcp/actions';

const actions = new Actions();

actions.addFilter('add_to_cart_data', (data, cart) => {
    const formData = $('form.cart [name^="wapf["]').serializeArray();
    const wapf = {};

    formData.forEach(({name, value}) => {
        const match = name.match(/^wapf\[(field_[\w]+)]/);
        if (match) {
            const key = match[1];
            if (wapf[key]) {
                // Handle multiple values - convert to array or append
                wapf[key] = Array.isArray(wapf[key])
                    ? [...wapf[key], value]
                    : [wapf[key], value];
            } else {
                wapf[key] = value;
            }
        }
    });

    return {
        ...data,
        wapf,
        wapf_field_groups: $('[name="wapf_field_groups"]').val()
    };
});